import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { AccountUserService } from 'src/app/services/account-user.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DateFormatPipe } from 'src/app/pipes/dateFormat.pipe';
import { AccountService } from 'src/app/services/account.service';
@Component({
  selector: 'app-account-stat',
  templateUrl: './account-stat.component.html',
  styleUrls: ['./account-stat.component.css']
})
export class AccountStatComponent implements OnInit {
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  filterParams: string;
  DateCatogory = 'TODAY';
  account = false;
  public userForm: UntypedFormGroup;
  appt: any;
  apptcreatedOn: any;
  apptcreatedFor: any;
  apptcreatedDue: any;
  tokencreatedOn: any;
  orderCreatedOn: any;
  tokencreatedFor: any;
  orderCreatedFor: any;
  tokencreatedDue: any;
  orderBookingDueCreatedFor: any;
  donationCreatedOn: any;
  prepaymentCreatedOn: any;
  datege;
  statType: string;
  StatDateType: string;
  datas: Object;
  salesChannel: any;
  filtervalue: any;
  account_value;
  showlist;
  day_value;
  enddate;
  startdate;
  GoSPlistAppt;
  GoSPlistApptFor;
  GoSPlistApptDue;
  day_select: string;
  showdatedata;
  account_select;
  hideName = false;
  hidetype = false;
  scConfig: any = {};
  datePipe = new DatePipe('en-US');
  datele;
  dayTypes: any = [];
  paymentOn: any;
  paymentOn_ge: any;
  paymentOn_le: any;
  daydata;
  fildata;
  isNotdaterange = false;
  tableFilters: any = '';
  accdata;
  startpicker;
  endpicker;
  selectedFilter: string;
  api_error: any;
  api_success: any;
  today = new Date();
  showchecked;
  accountid;
  subDomains: any = [];
  filterParamCustomer: string;
  serviceSectors: any;
  domain: any;
  domainModel = 0;
  todayDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  Type = 'All';
  store_filterValue: any;
  teleservice: boolean;
  tele_value;
  mode_value: any;
  isShowTknAppt: boolean = true;
  online: any;
  walkin: any;
  phonein: any;
  newlysignedfilterParam = '';
  accountData: any = {};
  accountId: any;
  account_id: any;
  createdDate_operator = 'inbetween';
  showaccId= false;
  hideaccId= true;
  constructor(private router: Router, private route: ActivatedRoute, private accountService: AccountService,private commonService: CommonfilterService, private activatedRoute: ActivatedRoute, private commonfilterService: CommonfilterService, public dateformat: DateFormatPipe, private formBuilder: UntypedFormBuilder, private commonservice: CommonfilterService, private commonFilter: CommonfilterService, private accountuserService: AccountUserService,) {
    this.commonfilterService.getConfigData()
      .subscribe(res => {
        this.scConfig = res;
        this.dayTypes = this.scConfig.pastStatDateCategoryDetails;
      });
    this.commonService.getServiceSectors()
      .subscribe(res => {
        this.serviceSectors = res;
      });
  }
  ngOnInit() {
    this.getBooking();
    this.showchecked = true
    this.activatedRoute.queryParams.subscribe(params => {
      this.daydata = params.dateCatogory;
      this.fildata = params.filterApplied;
      this.startpicker = params.startDate;
      this.endpicker = params.endDate;
      this.accdata = params.isIncludeTest;
      this.accountId = params.accountId;
    });
    this.account_id = this.accountId
    // if (this.daydata && this.fildata) {
    //   let newlyfilterParam = '';
    //   newlyfilterParam = this.daydata + '/withTest' + '/' + this.accdata + '/stats' + '?' + this.fildata;;
    //   this.getBooking1(newlyfilterParam);
    // }
    if (this.accdata == 'true') {
      this.showchecked = true;
    }
    if (this.accdata == 'false') {
      this.showchecked = false;
    }
  }
  onChange(event) {
    if (event.target.value === 'DATE_RANGE') {
      this.showaccId =  true;
      this.hideaccId= false;
      this.hideName = true;
      this.isNotdaterange = true
    }
    else {
      this.showaccId =  false;
      this.hideaccId= true;
      this.hideName = false;
      this.isNotdaterange = false;
    }
  }
  getAccounts() {
    this.tableFilters = this.commonService.filterParams_without_operators('bookingStat');
    this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/stats' + '?' + 'date-le=' + this.datele + '&date-ge=' + this.datege + '&' + 'tele_service=' + this.teleservice + '&';
    this.accountData.filterParam = this.newlysignedfilterParam;
    this.accountService.storeAccountData(this.accountData);
    this.router.navigate(['../accounts/filter/list'], { queryParams: { accountId: 'stat' }, relativeTo: this.activatedRoute });

    // })

  }
  // getBooking1(newlyfilterParam) {
  //   this.api_error = '';
  //   this.api_success = '';
  //   this.accountuserService.getStat(newlyfilterParam).subscribe(
  //     (data) => {
  //       this.apptcreatedOn = data.apptCreatedOn;
  //       this.apptcreatedFor = data.apptCreatedFor;
  //       this.apptcreatedDue = data.apptBookingDueCreatedFor;
  //       this.tokencreatedOn = data.checkinCreatedOn;
  //       this.tokencreatedFor = data.checkinCreatedFor;
  //       this.tokencreatedDue = data.checkinBookingDueCreatedFor;
  //       this.donationCreatedOn = data.donCreatedOn;
  //       this.prepaymentCreatedOn = data.prepaymentCreatedOn;
  //     },
  //     (error) => {
  //       this.api_error = error.error;
  //     });
  // }
  getBooking() {
    this.account_value = this.account;
    this.day_value = this.DateCatogory;
    this.startdate = this.datege;
    this.enddate = this.datele;
    this.tele_value = this.teleservice;
    if (this.teleservice === undefined) {
      this.tele_value = false;
    }

    this.tableFilters = this.commonService.filterParams_without_operators('bookingStat');
    this.store_filterValue = this.tableFilters;
    if (this.DateCatogory === 'DATE_RANGE') {
      if (this.teleservice) {
        this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/stats' + '?' + 'date-le=' + this.datele + '&date-ge=' + this.datege + '&' + 'tele_service=' + this.teleservice + '&';
        this.selectMode();
      } else {
        this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/stats' + '?' + 'date-le=' + this.datele + '&date-ge=' + this.datege + '&' ;
        this.selectMode();
      }

    } else {
      if (this.teleservice) {
        this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/stats' + '?' + 'tele_service=' + this.teleservice + '&';
        this.selectMode();
      }

      else {
        this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/stats?' ;
        this.selectMode()
      }
    }
    this.api_error = '';
    this.api_success = '';
    this.accountuserService.getStatBooking(this.newlysignedfilterParam).subscribe(
      (data) => {
        this.apptcreatedOn = data.apptCreatedOn;
        this.apptcreatedFor = data.apptCreatedFor;
        this.apptcreatedDue = data.apptBookingDueCreatedFor;
        this.tokencreatedOn = data.checkinCreatedOn;
        this.tokencreatedFor = data.checkinCreatedFor;
        this.tokencreatedDue = data.checkinBookingDueCreatedFor;
        this.orderCreatedOn = data.orderCreatedOn;
        this.orderCreatedFor = data.orderCreatedFor;
        this.orderBookingDueCreatedFor = data.orderBookingDueCreatedFor;
        this.donationCreatedOn = data.donCreatedOn;
        this.prepaymentCreatedOn = data.prepaymentCreatedOn;
      },
      (error) => {
        this.api_error = error.error;
      });
  }
  selectMode() {
    if (this.online && !this.walkin && !this.phonein) {
      this.changeMode('online')
    }
    else if (!this.online && this.walkin && !this.phonein) {
      this.changeMode('walkin')
    }
    else if (!this.online && !this.walkin && this.phonein) {
      this.changeMode('phonein')
    }
    else if (this.online && this.walkin && !this.phonein) {
      this.changeMode('online,walkin')
    }
    else if (!this.online && this.walkin && this.phonein) {
      this.changeMode('walkin,phonein')
    }
    else if (this.online && !this.walkin && this.phonein) {
      this.changeMode('online,phonein')
    }
    else if (this.online && this.phonein && this.walkin) {
      this.changeMode('online,walkin,phonein')
    }
    else {
      this.changeMode('default')
    }
  }
  changeMode(mode) {
    this.mode_value = mode;
    switch (mode) {
      case 'online':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'online' + '&' + this.tableFilters
        // this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/stats' + '?' + 'booking_mode=' + 'online' + '&' + this.tableFilters; 
        break;
      case 'walkin':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'walkin' + '&' + this.tableFilters;
        break;

      case 'phonein':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'phonein' + '&' + this.tableFilters;
        break;
      case 'online,walkin':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'online,walkin' + '&' + this.tableFilters;
        break;
      case 'walkin,phonein':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'walkin,phonein' + '&' + this.tableFilters;
        break;
      case 'online,phonein':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'online,phonein' + '&' + this.tableFilters;
        break;
      case 'online,walkin,phonein':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'online,walkin,phonein' + '&' + this.tableFilters;
        break;
      default:
        this.newlysignedfilterParam = this.newlysignedfilterParam+this.tableFilters;
    }

  }
  onDomainChange(event) {
    this.subDomains = [];
    for (let i = 0; i < this.serviceSectors.length; i++) {
      if (event.target.value == this.serviceSectors[i].id) {
        this.domain = this.serviceSectors[i].domain;
        for (let j = 0; j < this.serviceSectors[i].subDomains.length; j++) {
          this.subDomains.push({
            'displayName': this.serviceSectors[i].subDomains[j].displayName,
            'id': this.serviceSectors[i].subDomains[j].id, 'subDomain': this.serviceSectors[i].subDomains[j].subDomain
          });
        }
      }
    }
  }
  ontypeChange(event) {
    if (event.target.value === 'token_appt') {
      this.hidetype = true;
      this.isShowTknAppt = false;
    }
    else if (event.target.value === 'All') {
      this.online = '';
      this.walkin = '';
      this.phonein = '';
      this.hidetype = false;
      this.isShowTknAppt = true;
    }
  }
}